<template>
    <span v-if="navPermissions['portalAdmin'].enable">
        <a
            id="nav-admin-collapse"
            :aria-expanded="adminCollaps"
            class="sidebar-menu-item nav-link"
            data-toggle="collapse"
            @click="(adminCollaps=!adminCollaps)">
            <template>
                <i class="fa pr-2 fa-lock text-blue"></i>
                <span class="nav-link-text">Administration <b class="caret"></b></span>
            </template>
        </a>
        <collapse-transition :duration="{enter: 500, leave: 500}">
            <div v-show="adminCollaps" id="collapse-just" :class="adminCollaps?'show':''" class="collapse">
                <ul class="nav nav-sm flex-column">
                    <slot name="title">
                        <router-link
                            id="nav-admin-user-management"
                            :target="link.target"
                            class="nav-link"
                            href="/admin/user_admin"
                            to="/admin/user_admin"
                            @click.native="linkClick">
                            <template>
                                <i class="fa fa-user text-danger pr-2"></i>
                                <span class="nav-link-text">User Management</span>
                            </template>
                        </router-link>

                        <router-link
                            id="nav-admin-product-management"
                            v-if="isNsim"
                            :target="link.target"
                            class="nav-link"
                            href="/admin/product_management"
                            to="/admin/product_management"
                            @click.native="linkClick">
                            <template>
                                <i class="fa fa-archive text-cyan pr-2"></i>
                                <span class="nav-link-text">Product Management</span>
                            </template>
                        </router-link>

                        <!-- <router-link
                            v-if="isPortalAdminStatus"
                            :target="link.target"
                            class="nav-link"
                            href="/admin/carrier_links"
                            to="/admin/carrier_links"
                            @click.native="linkClick">
                            <template>
                                <i class="fas fa-link text-gray pr-2"></i>
                                <span class="nav-link-text">Carrier Links</span>
                            </template>
                        </router-link> -->


                      <!--                        <router-link-->
                      <!--                            v-if="isPortalAdminStatus"-->
                      <!--                            :target="link.target"-->
                      <!--                            class="nav-link"-->
                      <!--                            href="/admin/simtool"-->
                      <!--                            to="/admin/simtool"-->
                      <!--                            @click.native="linkClick">-->
                      <!--                            <template>-->
                      <!--                              <i class="fa fa-magnet text-orange" font-scale="1"></i>-->
                      <!--                              Sim Tool-->
                      <!--                                &nbsp; <i class="fa fa-lock text-gray size-32"></i>-->
                      <!--                            </template>-->
                      <!--                        </router-link>-->

                    </slot>
                </ul>
            </div>
        </collapse-transition>
    </span>
</template>

<script>
import {CollapseTransition} from "vue2-transitions";
import initService from "@/common/api-services/init-service";
import configDirective from "@/common/directive/config-directive";

export default {
  name: 'side-admin-basic-group',
  components: {
    CollapseTransition
  },

  data() {
    return {

      isNsim:false,
      isPortalAdminStatus: false,
      isAdminStatus: false,
      groups: [],

      adminCollaps: false,
      link: {
        name: '',
        icon: '',
        path: '',
        children: []
      },

      navPermissions: {
        "portalAdmin": {
          enable: false,
          role: ["Administrator"],
          data: {
            "adminAccess": {
              enable: false,
              role: ["Administrator"]
            },
          }
        }
      }
    }
  },

  mounted() {
    this.isPortalAdminStatus = initService.getPortalAdminRole();
    this.isAdminStatus = initService.getAdministratorRole() || initService.getPortalAdminRole();
    this.groups = initService.getGroups();
    Object.keys(this.navPermissions).map(item => {
      this.groups.map(it => {
        if (this.navPermissions[item].role.includes(it)) this.navPermissions[item].enable = true;
      });
    });

    this.isNsim = configDirective.hasNsim();
  },

  methods: {
    linkClick() {
      if (
          this.autoClose &&
          this.$sidebar &&
          this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    },
  }

}
</script>
